module.exports = __webpack_public_path__ + "static/media/1000978.3868d994.png";